export default __webpack_public_path__ + "static/InterDisplay-Medium-1841e3d863f392d13f4bc4dbe174b8a2.woff";